define('lib/Podio.UI.Balloon.AutoShow',['require','jquery','lib/jquery/jquery.balloon','lib/Podio.Event'],function(require) {

  var $ = require('jquery');
  require('lib/jquery/jquery.balloon');

  var podioEvent = require('lib/Podio.Event');

  function onDomReady() {
    showAutoBalloon();
  }

  function showAutoBalloon() {
    var elmBalloonAnchors = $('.show-balloon');
    elmBalloonAnchors.each(function(){
      var elmBalloonAnchor = $(this);
      var settings = elmBalloonAnchor.data('balloon');
      elmBalloonAnchor.balloon(settings);
    });
  }

  podioEvent.bind(podioEvent.Types.init, onDomReady);

});

